import React from 'react'
import { connect } from 'react-redux'
import { getPageName } from 'services/utility'
import { STORE_LOC_URL, STORE_LOC_CMPID } from 'services/utility/constants'
import Profile from '../asda-com/Profile'

export const TopNav = () => (
  <div className="top-nav">
    <ul>
      <li className="find-store">
        <a
          href={`${STORE_LOC_URL}?${STORE_LOC_CMPID.replace(
            'page-name',
            getPageName(),
          )}`}
        >
          <i className="icon-pin" />
          Find a store
        </a>
      </li>
      <Profile isBabyClubHeader />
    </ul>
  </div>
)

export default connect()(TopNav)



// WEBPACK FOOTER //
// ./components/header/baby-club/TopNav.js